import { GuidesPage } from "../../GuidesPage";
import { seoContent } from "../../../../constants/SEOConstant";
import { PairSyncGuideContent } from "../../PairSyncGuideContent";

export default function SyncAppleMusicToYoutube() {
    return (
        <GuidesPage
            seoData={seoContent.syncAppleMusicToYoutube}
            sections={<PairSyncGuideContent sourceKey="appleMusic" destKey="youtube" />}
        />
    );
}
